import { useCallback, useEffect, useState } from 'react';
import {
  clearStoredAccessKey,
  fetchFluxPromptSampleBuildInfo,
  getStoredAccessKey,
  verifyFluxPromptSampleAccess,
} from '../utils/fluxPromptSampleApi';
import './FluxPromptSampleAccessGate.css';

export default function FluxPromptSampleAccessGate({ children }) {
  const [ready, setReady] = useState(false);
  const [key, setKey] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [rev, setRev] = useState('');
  const [configured, setConfigured] = useState(true);

  useEffect(() => {
    fetchFluxPromptSampleBuildInfo()
      .then((d) => {
        setRev(d?.rev || '');
        setConfigured(d?.access_configured !== false);
      })
      .catch(() => {});
    if (getStoredAccessKey()) setReady(true);
  }, []);

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setBusy(true);
      setError('');
      try {
        await verifyFluxPromptSampleAccess(key.trim());
        setReady(true);
      } catch (err) {
        setError(err.message || 'Access denied');
        clearStoredAccessKey();
      } finally {
        setBusy(false);
      }
    },
    [key]
  );

  if (ready) return children;

  return (
    <div className="fps-gate">
      <div className="fps-gate-card">
        <h1>FLUX prompt sample</h1>
        <p className="fps-gate-lead">Standalone lab — not salon, franchise, or kiosk login.</p>
        {!configured ? (
          <p className="fps-gate-warn" role="alert">
            Server: set <code>FLUX_PROMPT_SAMPLE_API_KEY</code> in backend <code>.env</code>.
          </p>
        ) : null}
        <form onSubmit={onSubmit}>
          <label className="fps-gate-label" htmlFor="fps-access-key">Access key</label>
          <input
            id="fps-access-key"
            type="password"
            className="fps-gate-input"
            autoComplete="off"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="Enter lab access key"
          />
          <button type="submit" className="fps-gate-btn" disabled={busy || !key.trim()}>
            {busy ? 'Checking…' : 'Continue'}
          </button>
        </form>
        {error ? <p className="fps-gate-error" role="alert">{error}</p> : null}
        {rev ? <p className="fps-gate-rev">rev {rev}</p> : null}
      </div>
    </div>
  );
}
